import { Message, Notification } from "element-ui";
import address from "../../config/address.config";
const axios = require("axios");

const CancelToken = axios.CancelToken;
const source = CancelToken.source();
window.$apiCancel = source;
//邮件详情、邮件列表、文件夹目录三个接口在超过2.5s后获取浏览器本地缓存
// let apiArr = ["/exchangeapi/emails/id", "/exchangeapi/emails", "/exchangeapi/folders"]
let apiArr = [
  "/webmailapi/emails/id",
  "/webmailapi/emails",
  "/webmailapi/folders"
];
const checkIndexOf = (target, key) => {
  return typeof target === "string" && target.indexOf(key) > -1;
};

function apiAxios(method, opts, params, success, failure) {
  let _opts = {
      method,
      withCredentials: false,
      headers: {
        token: localStorage.Token
      }
    },
    args = Array.of(arguments);

  return new Promise((resolve, reject) => {
    //将数据保存到浏览器本地
    function saveLocal(data) {
      // axios方式请求时opts参数不是字符串，打断执行；get和post方式请求时opts参数均为字符串；
      // 进行浏览器缓存的三个接口均为get或post请求
      if (typeof opts != "string") return;
      //邮件详情（缓存到浏览器本地）
      if (checkIndexOf(opts, apiArr[0])) {
        let emailInfoObj = data;
        window.$utils.localSaveEmailInfo(emailInfoObj);
      }
      //邮件列表（缓存到浏览器本地）（只保存邮件列表第一页）
      if (opts === apiArr[1] && params.data.page === 1) {
        let emailListObj = data;
        emailListObj.emailListJson = JSON.stringify(params);
        window.$utils.localSaveEmailList(emailListObj);
      }
      //文件夹目录（缓存到浏览器本地）
      if (opts === apiArr[2]) {
        let folderObj = data;
        folderObj.Token = localStorage.Token;
        window.$utils.localSaveFolder(folderObj);
      }
    }
    //在浏览器本地是否找到对应数据
    let isFindLocalData = false;
    //从浏览器本地获取数据
    function getLocal() {
      // axios方式请求时opts参数不是字符串，打断执行；get和post方式请求时opts参数均为字符串；
      // 进行浏览器缓存的三个接口均为get或post请求
      if (typeof opts != "string") return;
      //邮件详情（获取浏览器本地缓存）
      if (checkIndexOf(opts, apiArr[0])) {
        window.$localforage
          .getItem("emailInfoArr")
          .then(val => {
            let tempNum = 0;
            val.forEach((item, index, arr) => {
              if (item.Data.Id === params.data.Id && tempNum === 0) {
                if (item.Data.Attachments.length > 0) {
                  //浏览器本地存储的邮件详情可能包含过期的token，替换为本地存储的有效token
                  var reg = /\/emails\/attachments\/id\?token=([^\s\t\r\n""'<>]*)&id=/,
                    oldTokenT = item.Data.Attachments[0].Attach_ServerPath.match(
                      reg
                    );
                  item.Data.Attachments.forEach((v, k) => {
                    if (oldTokenT) {
                      let oldToken = oldTokenT[1],
                        newToken = localStorage.Token,
                        regToken = new RegExp(oldToken, "g"); //全文匹配
                      v.Attach_ServerPath = v.Attach_ServerPath.replace(
                        regToken,
                        newToken
                      );
                    }
                  });
                }
                isFindLocalData = true;
                resolve(item);
                success && success(item);
                tempNum++;
              }
            });
          })
          .catch(err => {
            //console.log(err)
          });
      }
      //邮件列表（获取浏览器本地缓存）
      if (opts === apiArr[1]) {
        window.$localforage
          .getItem("emailListArr")
          .then(val => {
            let tempNum = 0;
            val.forEach((item, index, arr) => {
              if (
                item.emailListJson === JSON.stringify(params) &&
                tempNum === 0
              ) {
                isFindLocalData = true;
                resolve(item);
                success && success(item);
                tempNum++;
              }
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
      //文件夹目录（获取浏览器本地缓存）
      if (opts === apiArr[2]) {
        window.$localforage
          .getItem("folderArr")
          .then(val => {
            let tempNum = 0;
            val.forEach((item, index, arr) => {
              if (item.Token === localStorage.Token && tempNum === 0) {
                isFindLocalData = true;
                resolve(item);
                success && success(item);
                tempNum++;
              }
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
    }

    // 统一添加请求参数Token和UserId
    // params.UserId = localStorage.UserId
    // params.Token = localStorage.Token

    // 参数合并 当时对象时，回调重新绑定
    // axios 行驶中注意默认的请求方式为 post
    if (method !== "axios" && typeof method === "string") {
      _opts.url = opts;
      method === "POST" ? (_opts.data = params) : (_opts.params = params);
    } else {
      opts.method.match(/post/i)
        ? (_opts.data = params)
        : (_opts.params = params);
      $.fn.extend(true, _opts, opts);
    }
    _opts.cancelToken = source.token;

    let isGetLocalData = false; //是否获取本地缓存数据
    //接口请求超过2.5s将获取本地浏览器缓存数据
    let timerGL = setTimeout(() => {
      isGetLocalData = true;
      getLocal();
    }, 2500);

    axios(_opts)
      .then(res => {
        let DATA = res.data,
          CODE = 200,
          STATUS;

        CODE = DATA.Code;
        STATUS = DATA.Success ? DATA.Success : false;
        // 实现登录超时的重登陆
        if (CODE === -40001) {
          window.$utils.clearLocalStorageUserInfo();
          location.href = location.origin;
        }

        if (STATUS === true) {
          //邮件列表、邮件详情、文件夹目录三个接口调用时走此判断
          if (
            checkIndexOf(opts, apiArr[0]) ||
            opts === apiArr[1] ||
            opts === apiArr[2]
          ) {
            if (isGetLocalData) {
              //大于2.5s，获取浏览器本地数据
              console.log("isFindLocalData:" + isFindLocalData);
              if (!isFindLocalData) {
                //在浏览器本地没有找到对应的数据
                resolve(DATA);
                success && success(DATA);
              }
              saveLocal(DATA); //更新浏览器本地缓存数据
            } else {
              //小于2.5s，使用接口获取到的数据
              clearTimeout(timerGL); //清除定时器
              resolve(DATA);
              success && success(DATA);
              saveLocal(DATA); //更新浏览器本地缓存数据
            }
          } else {
            resolve(DATA);
            success && success(DATA);
          }
        } else {
          /*
        	1、接口调用时间超过2.5s（超过2.5s后会去查找浏览器本地缓存），isGetLocalData=true；
          2、且在浏览器本地缓存中找到了对应数据，isFindLocalData=true；
          （如果可以在本地找到对应数据则当前调用的接口一定是“邮件列表、邮件详情、文件夹目录”中的一个）；
        	以上两个条件都满足时将当前函数return打断
        	*/
          if (isGetLocalData && isFindLocalData) return;
          reject(DATA);
          if (failure) {
            failure(DATA);
          } else {
            Message("数据加载出错：" + DATA.Message);
          }
        }
      })
      .catch(function(err) {
        reject(err);
        // 邮箱服务器异常警告提示
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.Code === -40016
        ) {
          Notification({
            // title: "警告",
            message: err.response.data.Message,
            type: "warning",
            position: "bottom-right",
            duration: 3000
          });
        } else if (err.response.status == "429") {
          if (failure) {
            failure(err.response);
          } else {
            Message.warning(i18n.t("requestLimitTip"));
          }
        } else {
          Message.warning(err.response.data.Message);
          // 如果报“无效token”的错误，则跳转到用户中心登录界面
          if (err.response.data.Message === "无效Token") {
            setTimeout(() => {
              location.href = address.getSSOURL() + location.origin;
            }, 3000);
          }
        }
      });
  });
}

// 返回在vue模板中的调用接口
export default {
  axios: function(opts, success, failure) {
    return apiAxios("axios", opts, {}, success, failure);
  },
  get: function(opts, params, success, failure) {
    return apiAxios("GET", opts, params, success, failure);
  },
  post: function(opts, params, success, failure) {
    return apiAxios("POST", opts, params, success, failure);
  }
  // put: function(opts, params, success, failure) {
  //   return apiAxios("PUT", opts, params, success, failure)
  // },
  // delete: function(opts, params, success, failure) {
  //   return apiAxios("DELETE", opts, params, success, failure)
  // }
};



// WEBPACK FOOTER //
// ./src/api/index.js